export const PARCEL_VALUE_HIGH = 'H';
export const NOT_AVAILABLE = 'Not Available';

export const ORIGIN = {
  FMP: 'PRTK',
  EMAIL: 'NOTE',
  SMS: 'NOTS',
  PRCU: 'PRCU',
};
